import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/about/About-us-carousel-bubbles_68x342px.svg")